import { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import clone from 'ramda/src/clone';
import concat from 'ramda/src/concat';
import find from 'ramda/src/find';
import includes from 'ramda/src/includes';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import prop from 'ramda/src/prop';
import propEq from 'ramda/src/propEq';
import sortBy from 'ramda/src/sortBy';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import OptionButton from '@components/@core/Button';
import DatePicker from '@components/@core/DatePicker';
import Dropdown from '@components/@core/Dropdown';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import EditDropdown from '@components/EditDropdown';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import Input from '@components/@core/Input';
import Text from '@components/@core/Text';
import Toggle from '@components/@core/Toggle';
import Upload from '@components/@core/Upload';
import AppActions from '~/actions/app';
import ManageActions from '~/actions/manage';
import { UserRoles } from '~/services/config';
import { formatDate } from '~/services/util';
import Accepted from './Accepted';
import Agreed from './Agreed';
import * as Quota from './Quota';
import * as Commitments from './Commitments';
import { IndividualMonthPdf } from './IndividualMonthPdf';
import withNavigate from '~/hocs/withNavigate';

import QuillEditor from '@components/@core/QuillEditor';

const ReactQuill = QuillEditor; // Alias for backward compatibility

const getAvgStars = (reviews) => {
    let stars = 0;
    let counts = 0;
    reviews.forEach((item) => {
        if (item.status == 2) {
            counts += 1;
            if (item.data?.average_star_rating !== 'N/A') {
                stars += item.data?.average_star_rating;
            }
        }
    });
    return (stars / counts).toFixed(2);
};

class ScorecardDetail extends Component {
    constructor(props) {
        super(props);

        const values = queryString.parse(props.location.search);
        const dateStart = new Date(values.date_start);
        let editable;
        let completed;
        if (includes('report-performance', props.location.pathname)) {
            editable = false;
            completed = true;
        } else {
            editable = props.data.performance.status !== 2;
            completed = props.data.performance.status === 2;
        }

        const companyId = props.data.performance.company_id || props.companyId;
        const company = find(propEq('id', companyId), props.companies) || {};
        const managers = company.managers || [];
        const roles = company.job_roles || [];

        const id = Number(props.match?.params?.id);
        let user = find(propEq('id', id), props.users) || { profile: {} };
        const job = find(propEq('id', user.job_role_id), roles) || {};
        user = { ...user, job };
        const manager = props.role < 4 ? props.user : find((item) => item.id == user.manager_id, managers);

        this.state = {
            note: props.data.performance?.data?.coaching?.comments || '',
            user,
            manager,
            companyId,
            managers,
            roles,
            selectedMonth: {
                start: moment(dateStart).utc().startOf('month'),
                end: moment(dateStart).utc().endOf('month'),
            },
            editable,
            completed,
            email1: user?.email,
            pass1: '',
            email2: manager?.email,
            pass2: '',
            files: [],
        };
    }

    componentDidMount() {
        const { data } = this.props;

        let visible = false;
        data.scorecards.forEach((item) => {
            if (item.quotas.length > 0) visible = true;
        });
        if (visible) this.handleActualModal();

        const { companyId, selectedMonth, user } = this.state;
        const dateStart = moment(selectedMonth.start).format('YYYY-MM-DD');
        const dateEnd = moment(selectedMonth.end).format('YYYY-MM-DD');
        const payload = { userId: user.id, companyId, dateStart, dateEnd };
        this.props.fetchReviews(payload);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data?.performance?.data?.coaching?.comments !== this.props.data?.performance?.data?.coaching?.comments) {
            this.setState({ note: this.props.data?.performance?.data?.coaching?.comments ?? '' });
        }
    }

    handleAdd = (e) => {
        const { companyId, user, selectedMonth } = this.state;
        const payload = {
            ...e,
            cardType: 'task',
            type: 'single',
            performanceId: this.props.data.performance.id,
            companyId: companyId,
        };
        const after = {
            type: 'INDIVIDUALPERFORMANCEREVIEW_REQUEST',
            payload: {
                userId: user.id,
                companyId,
                dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
            },
        };
        this.props.assignCard(payload, after);
    };

    handleAssign = (e) => {
        const { selectedMonth } = this.state;
        const ids = e.templates;
        let payload = {
            userId: [this.state.user.id],
            performanceId: this.props.data.performance.id,
            companyId: this.state.companyId,
            cardTemplateId: ids,
            cardType: 'courses',
            dueDate: e.due_date,
        };
        if (e.type === 'tracks') payload = { ...payload, cardType: 'tracks' };
        const after = {
            type: 'INDIVIDUALPERFORMANCEREVIEW_REQUEST',
            payload: {
                userId: this.state.user.id,
                companyId: this.state.companyId,
                dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
            },
        };
        this.props.assignCard(payload, after);
    };

    handleDate = (e) => {
        const { user, companyId } = this.state;
        this.props.fetchPrevious(this.props.data.performance.id, user.id, {
            dateStart: moment(e.start).format('YYYY-MM-DD'),
            dateEnd: moment(e.end).format('YYYY-MM-DD'),
        });
        this.props.fetchReviews({
            userId: user.id,
            companyId,
            dateStart: moment(e.start).format('YYYY-MM-DD'),
            dateEnd: moment(e.end).format('YYYY-MM-DD'),
        });
        this.setState({ selectedMonth: e });
    };

    handleFilter = (type, e) => {
        const { companyId, roles, selectedMonth } = this.state;
        if (type === 'employee') {
            if (e[0].id < 0) return;
            const user = e[0];
            const job = find(propEq('id', user.job_role_id), roles) || {};
            this.props.fetchReviews({
                userId: e[0].id,
                companyId,
                dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
            });
            this.setState({ user: { ...user, job } });
        } else {
            this.props.fetchReviews({
                userId: this.state.user.id,
                companyId: e[0].id,
                dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
            });
            this.setState({ companyId: e[0].id });
        }
    };

    handleTask = () => {
        const { projects } = this.props;
        const performanceProject = find(propEq('name', 'Reviews'), projects);
        const payload = {
            type: 'Add New Task',
            data: {
                before: {
                    assignees: [this.state.user.id],
                    projectId: performanceProject?.id || null,
                },
            },
            callBack: { onAdd: this.handleAdd },
        };
        this.props.toggleModal(payload);
    };

    handleTraining = () => {
        const payload = {
            type: 'Assign Training',
            data: {
                before: { assignees: [this.state.user.id], modules: [], companyId: this.state.companyId },
            },
            callBack: { onAssign: this.handleAssign },
        };
        this.props.toggleModal(payload);
    };

    handleActualModal() {
        const { user, companyId, selectedMonth } = this.state;
        if (this.props.data.performance.status === 2) return;
        const payload = {
            type: 'Save Actuals',
            data: {
                before: {
                    user,
                    date: moment(selectedMonth.start).format('YYYY-MM-DD'),
                    after: {
                        type: 'INDIVIDUALPERFORMANCEREVIEW_REQUEST',
                        payload: {
                            userId: user.id,
                            companyId: companyId,
                            dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                            dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
                        },
                    },
                },
            },
        };
        this.props.toggleModal(payload);
    }

    handleScorecardEdit = (e) => {
        switch (e) {
            case 'edit actuals':
                this.handleActualModal();
                break;
            case 'unassign scorecard':
                this.props.toggleModal({
                    type: 'Confirm',
                    data: {
                        before: {
                            title: 'Unassign Scorecard',
                            body: 'This will permanently delete the scorecard from your assignments.  Are you sure?',
                        },
                    },
                    callBack: {
                        onYes: () => {
                            this.props.deleteScorecard({ scorecard: { id: this.props.data.scorecards[0].id } });
                        },
                    },
                });
                break;
            default:
                break;
        }
    };

    handleSelectCommitMenu = (item, from) => (event) => {
        const { user, companyId } = this.state;
        const { card_type_id } = item;
        const { selectedMonth } = this.state;
        const mode = card_type_id === 8 ? 'task' : 'course';
        const priorAfterAction = {
            type: 'GETPREVIOUSREVIEWTASKS_REQUEST',
            payload: {
                id: this.props.data.performance.id,
                userId: user.id,
                payload: {
                    dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                    dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
                },
            },
        };
        const newAfterAction = {
            type: 'INDIVIDUALPERFORMANCEREVIEW_REQUEST',
            payload: {
                userId: user.id,
                companyId: companyId,
                dateStart: moment(selectedMonth.start).format('YYYY-MM-DD'),
                dateEnd: moment(selectedMonth.end).format('YYYY-MM-DD'),
            },
        };
        const after = from === 'new' ? newAfterAction : priorAfterAction;

        switch (event) {
            case 'detail view':
                if (card_type_id === 8) {
                    this.props.toggleModal({ type: 'Task Detail', data: { before: { card: item, after } } });
                } else {
                    this.props.fetchTask(item.id, 'Preview');
                }
                break;

            case 'edit':
                if (card_type_id === 8) {
                    this.props.toggleModal({ type: 'Edit Task', data: { before: { card: item, after } } });
                } else {
                    this.props.toggleModal({
                        type: 'Quick Edit',
                        data: { before: { template: item, type: 'courses', from: 'instance', after } },
                        callBack: {
                            onDelete: () => this.props.deleteTask(item.id, mode, after),
                        },
                    });
                }
                break;

            case 'delete':
                this.props.deleteTask(item.id, mode, after);
                break;

            default:
                break;
        }
    };

    handleSave = (e) => {
        if (e === 'Save & Exit') {
            const { note } = this.state;
            const performance = clone(this.props.data.performance);
            performance.data.coaching = { comments: note };
            performance.data.files = concat(performance.data.files || [], this.state.files);
            performance.status = 1;
            const payload = { performance };
            this.props.savePerformance(payload);
            this.props.navigate(-1);
        } else if (e === 'Save & Sign Off') {
            if (this.props.data.agreed?.employee && this.props.data.agreed?.supervisor) {
                const { note } = this.state;
                const performance = clone(this.props.data.performance);
                performance.data.coaching = { comments: note };
                performance.data.files = concat(performance.data.files || [], this.state.files);
                performance.status = 2;
                const payload = { performance };
                this.props.savePerformance(payload);
                this.props.navigate(-1);
            } else {
                toast.error('Your review should be agreed by both user first.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
            }
        } else {
            const { note } = this.state;
            const performance = clone(this.props.data.performance);
            performance.data.coaching = { comments: note };
            performance.data.files = concat(performance.data.files || [], this.state.files);
            const payload = { performance };
            this.props.savePerformance(payload);
        }
        this.setState({ files: [] });
    };

    handleReset = () => {
        const { companyId, selectedMonth } = this.state;
        const performance = clone(this.props.data.performance);
        const { id, user_id } = performance;
        const date_start = moment(selectedMonth.start).format('YYYY-MM-DD');
        const date_end = moment(selectedMonth.end).format('YYYY-MM-DD');
        const payload = {
            performance: {
                id,
                user_id,
                company_id: companyId,
                date_start,
                date_end,
            },
        };
        const after = {
            type: 'INDIVIDUALPERFORMANCEREVIEW_REQUEST',
            payload: {
                companyId,
                userId: user_id,
                dateStart: date_start,
                dateEnd: date_end,
            },
        };
        this.props.resetPerformance(payload, after);
    };

    handleDrop = (e) => {
        e.forEach((file) => {
            this.props.upload({ file }, this.handleUploadCallback, true);
        });
    };

    handleUploadCallback = (e) => {
        const files = clone(this.state.files);
        files.push(e);
        this.setState({ files });
    };

    handleRemove = (idx) => () => {
        if (idx < this.state.files.length) {
            const files = clone(this.state.files);
            files.splice(idx, 1);
            this.setState({ files });
        }
    };

    handleResetPassword = () => {
        this.props.toggleModal({ type: 'Reset Password' });
    };

    handleSign = (type) => () => {
        const { performance } = this.props.data;
        const { email1, email2, manager, note, pass1, pass2, user } = this.state;
        let sign = { performance_id: performance.id };

        if (type == 'employee') {
            sign = { ...sign, user_id: user.id, email: email1, password: pass1 };
        } else {
            sign = { ...sign, user_id: manager.id, email: email2, password: pass2 };
        }

        const completedPerformance = clone(this.props.data.performance);
        completedPerformance.data.coaching = { comments: note };
        completedPerformance.data.files = concat(performance.data.files || [], this.state.files);

        const agreed = this.props.data.performance?.data?.agreed;
        const completed = agreed ? completedPerformance : null;
        this.props.signPerformance(sign, completed);
    };

    handleReportMenu = (e) => {
        const { completed, manager, note, selectedMonth, user } = this.state;
        const { data, projects, reviews, users } = this.props;
        const avgStars = reviews.length ? getAvgStars(reviews) : 0;

        switch (e) {
            case 'print':
                IndividualMonthPdf({
                    avgStars,
                    completed,
                    data,
                    manager,
                    note,
                    projects,
                    reviews,
                    selectedMonth,
                    user,
                    users,
                });
                break;

            case 'reset status':
                this.props.toggleModal({
                    type: 'Confirm',
                    data: {
                        before: {
                            title: 'Reset Status',
                            warning: false,
                            body: 'Are you sure you want to Reset the status of this checkout as incomplete?',
                        },
                    },
                    callBack: {
                        onYes: () => {
                            this.handleReset();
                        },
                    },
                });
                break;
        }
    };

    render() {
        const { note, user, selectedMonth, editable, email1, email2, pass1, pass2 } = this.state;
        const { projects, data, role, reviews, users } = this.props;

        // Add safety check for data loading with debug info
        if (!data || !data.performance) {
            const debugInfo = {
                dataExists: !!data,
                performanceExists: !!data?.performance,
                dataKeys: data ? Object.keys(data) : 'no data',
                propsKeys: Object.keys(this.props),
            };

            return (
                <ErrorBoundary className="ind-performance-reviews">
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div>Loading scorecard details...</div>
                        <div style={{ fontSize: '12px', marginTop: '10px', color: '#666' }}>Debug: {JSON.stringify(debugInfo, null, 2)}</div>
                    </div>
                </ErrorBoundary>
            );
        }

        const { performance, scorecards } = data;
        const completed = performance?.status === 2;
        const { tasks, trainings } = performance;
        const agreed = performance?.data?.agreed;
        const userName = user.profile.first_name + ' ' + user.profile.last_name;

        return (
            <ErrorBoundary className="ind-performance-reviews">
                <Filter back="all reviews" onChange={this.handleFilter} />
                <div className="card mt-2 mt-md-0">
                    <div className="d-flex jc-between mt-3 mt-md-0">
                        <div className="d-flex">
                            <span className="dsl-b22 bold">Monthly Review</span>
                        </div>
                        <div className="d-flex d-h-end">
                            <DatePicker
                                className="mt-1 mt-md-0"
                                calendar="month"
                                append="caret"
                                format="MMM YY"
                                as="span"
                                align="right"
                                value={selectedMonth}
                                disabledDate={(e) => moment(e).isAfter(new Date())}
                                onSelect={this.handleDate}
                            />
                            <EditDropdown className="ms-3" dataCy="editDropdown" options={completed ? ['Print', 'Reset Status'] : ['Print']} onChange={this.handleReportMenu} />
                        </div>
                    </div>
                    <div className="mt-4 d-flex ssm-column">
                        <div className="preview-image">
                            <Avatar name={userName} url={user?.avatar} size="large" />
                        </div>
                        <div className="ms-md-4 mt-4 mt-md-0 text-center text-md-start">
                            <div className="d-flex ai-center mb-2">
                                <p className="dsl-m12 text-400 me-4">Name</p>
                                <p className="dsl-b16 text-400 ms-4 ps-2">{userName}</p>
                            </div>
                            <div className="d-flex ai-center mt-3">
                                <p className="dsl-m12 text-400 me-4">Review</p>
                                <p className="dsl-b16 ms-4">{selectedMonth.start.format('MMM YYYY')}</p>
                            </div>
                            <div className="d-flex ai-center mt-3">
                                <p className="dsl-m12 text-400 me-2">Scorecard</p>
                                <p className="dsl-b16 ms-4">{scorecards.length ? scorecards[0].title : 'N/A'}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4">
                        {scorecards.length === 0 ? (
                            <p className="dsl-d14 text-center mt-5">
                                {editable ? 'Cannot complete Performance Review until a scorecard is assigned.' : 'There are no Performance Review until a scorecard is assigned.'}
                            </p>
                        ) : (
                            <>
                                {scorecards.map((item) => {
                                    const quotas = sortBy(prop('created_at'), item.quotas);
                                    const monthlyQuotas = quotas.filter((quota) => (isNil(quota?.data?.quota_tracking) || quota?.data?.quota_tracking === 1) && quota.scorecard_id === item.id);
                                    return (
                                        <div className="mt-4" key={`ee${item.id}`}>
                                            <Quota.Header title="Quota" />
                                            <Quota.List quotas={monthlyQuotas} now={selectedMonth} editable={role < UserRoles.USER && !completed} onModal={this.handleScorecardEdit} />
                                            <div className="d-flex ssm-column ai-end">
                                                <div className="d-flex-1 mobile-full-quotas">
                                                    <Quota.Total quotas={quotas} now={selectedMonth} />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>

                <div className="card mt-2">
                    <div className="d-h-between">
                        <span className="dsl-b22 bold mb-2">Coaching Worksheet</span>
                        <span> {formatDate(selectedMonth.start, 'MMM, YYYY', '')} </span>
                    </div>
                    <p className="dsl-b18 bold mb-0 border-bottom py-4">Comments</p>
                    {completed ? (
                        <>
                            {note ? (
                                <div className="comments dsl-b16 border-bottom mt-3 pt-3" dangerouslySetInnerHTML={{ __html: note }} />
                            ) : (
                                <div className="comments d-flex jc-between border-bottom pt-3">
                                    <p className="dsl-b16 mt-3">No coaching notes were saved.</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <ReactQuill placeholder="Comment here" value={note} onChange={(e) => this.setState({ note: e })} />
                    )}

                    <p className="dsl-b18 bold mb-0 py-4 border-bottom mt-4">Tasks</p>
                    {reviews?.tasks?.length || tasks?.length ? (
                        <div className="tasks pb-3">
                            {reviews?.tasks?.map(
                                (task) =>
                                    task.user_id === user.id && (
                                        <Commitments.Task key={`e${task.id}`} role={role} task={task} users={users} projects={projects} yellow onSelect={this.handleSelectCommitMenu(task, 'prior')} />
                                    )
                            )}
                            {tasks?.map(
                                (task) =>
                                    task.user_id === user.id && (
                                        <Commitments.Task key={`e${task.id}`} role={role} task={task} users={users} projects={projects} onSelect={this.handleSelectCommitMenu(task, 'new')} />
                                    )
                            )}
                        </div>
                    ) : (
                        <div className="d-flex ai-center jc-between border-bottom py-3">
                            <p className="dsl-b16 mt-3">No tasks assigned</p>
                        </div>
                    )}
                    {!completed && role < UserRoles.USER && <Button className="ms-auto" type="low" name="+ Add Task" onClick={this.handleTask} />}
                    <p className="dsl-b18 bold mb-0 mt-5 pt-3 py-4 border-bottom">Learning</p>
                    {reviews?.trainings?.length || trainings?.length ? (
                        <div className="pb-3">
                            {reviews?.trainings?.map((training) => (
                                <Commitments.Training key={`f${training.id}`} role={role} training={training} users={users} yellow onSelect={this.handleSelectCommitMenu(training, 'prior')} />
                            ))}
                            {trainings?.map((training) => (
                                <Commitments.Training key={`e${training.id}`} role={role} training={training} users={users} onSelect={this.handleSelectCommitMenu(training, 'new')} />
                            ))}
                        </div>
                    ) : (
                        <div className="d-flex ai-center jc-between py-3 border-bottom">
                            <p className="dsl-b16 mt-3">No training assigned</p>
                        </div>
                    )}
                    {!completed && role < UserRoles.USER && <Button className="ms-auto" type="low" name="+ Add Training" onClick={this.handleTraining} />}
                </div>
                <div className="card mt-2">
                    {completed && agreed && (
                        <div className="agreed mb-3 mb-md-0">
                            <p className="dsl-b22 bold">Completed by:</p>
                            <div className="d-flex pt-3 ssm-column">
                                {agreed.supervisor && <Agreed title="Manager" data={agreed.supervisor} />}
                                {agreed.employee && <Agreed title="Employee" data={agreed.employee} />}
                            </div>
                        </div>
                    )}
                    {(!agreed?.supervisor || !agreed?.employee) && (
                        <>
                            <div className="d-flex ssm-column mt-3">
                                {!isEmpty(this.props.manager) && (
                                    <div className="sign-off d-flex-1 me-2">
                                        {isNil(agreed?.supervisor) ? (
                                            <>
                                                <Input
                                                    id="manager-email"
                                                    title="Manager email"
                                                    placeholder="Your email here..."
                                                    type="email"
                                                    value={email2}
                                                    onChange={(e) => this.setState({ email2: e })}
                                                />
                                                <Input
                                                    id="manager-pass"
                                                    className="mt-2"
                                                    title="Manager pass"
                                                    placeholder="Type Password..."
                                                    type="password"
                                                    value={pass2}
                                                    onChange={(e) => this.setState({ pass2: e })}
                                                />
                                                <div className="d-flex ai-center my-3">
                                                    <Button className="ms-auto" disabled={!email2 || !pass2} name="SUBMIT" onClick={this.handleSign('manager')} />
                                                </div>
                                            </>
                                        ) : (
                                            <Accepted data={agreed?.supervisor} />
                                        )}
                                    </div>
                                )}

                                <div className="sign-off d-flex-1 me-2">
                                    {isNil(agreed?.employee) ? (
                                        <>
                                            <Input
                                                id="employee-email"
                                                title="Employee email"
                                                placeholder="Your email here..."
                                                type="email"
                                                value={email1}
                                                onChange={(e) => this.setState({ email1: e })}
                                            />
                                            <Input
                                                id="employee-pass"
                                                className="mt-2"
                                                title="Employee pass"
                                                placeholder="Type Password..."
                                                type="password"
                                                value={pass1}
                                                onChange={(e) => this.setState({ pass1: e })}
                                            />
                                            <div className="d-flex ai-center my-3">
                                                <Button className="ms-auto" disabled={!email1 || !pass1} name="SUBMIT" onClick={this.handleSign('employee')} />
                                            </div>
                                        </>
                                    ) : (
                                        <Accepted data={agreed?.employee} />
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {!completed && (
                        <div className="d-flex jc-end pt-3">
                            <OptionButton className="ms-2" name="Save &" options={['Save & Exit', 'Save & Publish', 'Save & Sign Off']} onClick={this.handleSave} />
                        </div>
                    )}
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    role: state.app.app_role_id,
    user: state.app.user,
    userId: state.app.id,
    companies: state.app.companies,
    companyId: state.app.selectedCompany,
    users: state.app.users,
    data: state.manage.individualPerformanceReview,
    reviews: state.manage.previousReviews,
    projects: state.app.projects,
});

const mapDispatchToProps = (dispatch) => ({
    assignCard: (payload, after) => dispatch(ManageActions.assigntrainingRequest(payload, after)),
    savePerformance: (payload) => dispatch(ManageActions.postperformancereviewRequest(payload)),
    resetPerformance: (payload, after) => dispatch(ManageActions.postperformancereviewresetRequest(payload, after)),
    fetchReviews: (e) => dispatch(ManageActions.individualperformancereviewRequest(e, null)),
    fetchPrevious: (id, userId, e) => dispatch(ManageActions.getpreviousreviewtasksRequest(id, userId, e, false)),
    fetchTask: (cardId, mode) => dispatch(ManageActions.fetchtaskdetailRequest(cardId, mode)),
    deleteTask: (cardId, mode, after) => dispatch(ManageActions.deletetaskRequest(cardId, mode, after)),
    deleteScorecard: (e) => dispatch(ManageActions.postdeletescorecardRequest(e)),
    signPerformance: (payload, completed, after) => dispatch(ManageActions.postsignoffRequest(payload, completed, after)),
    toggleModal: (payload) => dispatch(AppActions.modalRequest(payload)),
    upload: (e, callback, toastflag) => dispatch(AppActions.uploadRequest(e, callback, toastflag)),
});

const ScorecardDetailWithNavigate = withNavigate(ScorecardDetail);
export default connect(mapStateToProps, mapDispatchToProps)(ScorecardDetailWithNavigate);
